import { createApp } from '@app/adapters/create-app'

import OpenTransactions from '.././open-transactions'

onDomLoad(function ($dom) {
  $dom.on('init-open-transactions', () => {
    $dom.find("[data-behaviour='open-transactions-modal']").each(function () {
      const data = JSON.parse(this.dataset.vueProps)

      createApp(OpenTransactions, {
        transactionType: data.transaction_type,
        detailedEntries: data.detailed_entries,
      }).mount(this)
    })
  })
})
